import {Injectable} from '@angular/core';
import {Dictionary, FieldDataRow, FieldKey} from '@twpub/core/models';
import _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class FieldProcessService {
  /**
   * Returns field data from dictionaries into a map of field data rows, grouped by field label.
   * @param dictionaries Array of dictionaries to process.
   * @param isSearchable Function to determine if a field is searchable.
   * @returns Map of field unique keys to FieldDataRow.
   */
  public getFieldMap(dictionaries: Dictionary[], isSearchable: (fieldKey: FieldKey) => boolean): Map<string, FieldDataRow> {
    const fieldMap = new Map<string, FieldDataRow>();
    dictionaries.forEach(dict => {
      dict.conceptFields.forEach(field => {
        if (field.fieldKey) {
          this.processField(fieldMap, field.fieldKey, dict, 'CONCEPT', isSearchable);
        }
      });
      dict.termFields.forEach(field => {
        if (field.fieldKey) {
          this.processField(fieldMap, field.fieldKey, dict, 'TERM', isSearchable);
        }
      });
    });
    return fieldMap;
  }

  private processField(fieldMap: Map<string, FieldDataRow>, fieldKey: FieldKey, dict: Dictionary, level: string, isSearchable: (fieldKey: FieldKey) => boolean): void {
    // Create a unique key for this field (level + label combination)
    const fieldUniqueKey = `${level}:${fieldKey.label}`;

    if (fieldMap.has(fieldUniqueKey)) {
      // This field already exists in the map, add this dictionary to it
      const existingRow = fieldMap.get(fieldUniqueKey)!;
      existingRow.dictionaries.push({
        id: dict.id,
        name: dict.name,
        fieldKey
      });
    } else {
      // Create a new row for this field
      fieldMap.set(fieldUniqueKey, {
        fieldKey,
        label: fieldKey.label,
        level: _.capitalize(level) as 'Concept' | 'Term',
        dictionaries: [{
          id: dict.id,
          name: dict.name,
          fieldKey
        }],
        searchable: isSearchable(fieldKey)
      });
    }
  }
}
